import { mdiExitToApp, mdiMenu } from "@mdi/js";
import Icon from "@mdi/react";
import axios from "axios";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import noktasal from "../../Assets/noktasal.png";
import { clearUserInfo } from "../../Redux/Slices/userSlice";
import { setCookieInDays } from "../../Utils/Cookies";
import { _appName, _clientLogo, _serverUrl2 } from "../../config";
import "./Navbar.css";

export default function Navbar(props) {
  const location = useLocation();
  const history = useHistory();
  const getUserInfo = useSelector((state) => state.getUserInfo);
  const dispatch = useDispatch();

  const visibleSidebar = () => {
    let dom = document.getElementById("sideBar");
    let closer = document.getElementById("sideBarCloser");

    if (dom.style.display === "block") {
      dom.style.display = "none";
      closer.style.display = "none";
    } else {
      dom.style.display = "block";
      closer.style.display = "block";
    }
  };

  const logoutFunc = () => {
    setCookieInDays("token", "0", 1);
    dispatch(clearUserInfo());
  };

  const onClickRoute = (url) => {
    if (location.pathname !== url) {
      history.push(url);
      visibleSidebar();
    }
  };

  return (
    <>
      <div className="navbarStyle">
        <div onClick={() => visibleSidebar()}>
          <Icon path={mdiMenu} size={1} className="sidebarHoverStyle" />
        </div>
        <b style={{ color: "rgb(230, 230, 230)", fontSize: "0.7rem" }}>{_appName}</b>
      </div>
      <div id="sideBar" className="sideBarContainer" style={{ display: "none" }}>
        <table style={{ width: "100%", marginBottom: "15px" }}>
          <thead>
            <tr>
              <td>
                <center>
                  <img src={_clientLogo} alt="" width="150px" />
                </center>
              </td>
            </tr>
          </thead>
        </table>

        <div style={{ backgroundColor: "rgba(255,255,255,0.38)", margin: "4px", padding: "2px", borderRadius: "10px" }}>
          <div className="d-flex justify-content-between">
            {" "}
            <Link to={"/dashboard/kullaniciDetay/" + getUserInfo.Username}>{getUserInfo.Username}</Link>{" "}
            <Icon path={mdiExitToApp} size={1} className="exitDiv" onClick={() => logoutFunc()} />
          </div>
        </div>
        {!props.empty && (
          <table style={{ width: "100%", marginTop: "15px" }}>
            <thead>
              {getUserInfo.Rol.includes("9") && (
                <tr className="sidebarHoverStyle" style={{ borderBottom: "1px solid rgba(255,255,255,0.38)" }}>
                  <td style={{ cursor: "pointer", fontSize: "13px" }} onClick={() => onClickRoute("/dashboard/statics")}>
                    <div className="d-flex justify-content-start">İstatistikler</div>
                  </td>
                </tr>
              )}
              {getUserInfo.Rol.includes("7") && (
                <tr className="sidebarHoverStyle" style={{ borderBottom: "1px solid rgba(255,255,255,0.38)" }}>
                  <td style={{ cursor: "pointer", fontSize: "13px" }} onClick={() => onClickRoute("/dashboard/hsign")}>
                    <div className="d-flex justify-content-start">Levha-Numarataj</div>
                  </td>
                </tr>
              )}
              {getUserInfo.Rol.includes("8") && (
                <tr className="sidebarHoverStyle" style={{ borderBottom: "1px solid rgba(255,255,255,0.38)" }}>
                  <td style={{ cursor: "pointer", fontSize: "13px" }} onClick={() => onClickRoute("/dashboard/sign")}>
                    <div className="d-flex justify-content-start">Direk/Duvar</div>
                  </td>
                </tr>
              )}
              {getUserInfo.Rol.includes("7") && (
                <tr className="sidebarHoverStyle" style={{ borderBottom: "1px solid rgba(255,255,255,0.38)" }}>
                  <td style={{ cursor: "pointer", fontSize: "13px" }} onClick={() => onClickRoute("/dashboard/data")}>
                    <div className="d-flex justify-content-start">Veri Yönetimi</div>
                  </td>
                </tr>
              )}
              {getUserInfo.Rol.includes("2") && (
                <tr className="sidebarHoverStyle" style={{ borderBottom: "1px solid rgba(255,255,255,0.38)" }}>
                  <td style={{ cursor: "pointer", fontSize: "13px" }} onClick={() => onClickRoute("/dashboard/team")}>
                    <div className="d-flex justify-content-start">Ekip Yönetimi</div>
                  </td>
                </tr>
              )}
              {getUserInfo.Rol.includes("6") && (
                <tr className="sidebarHoverStyle" style={{ borderBottom: "1px solid rgba(255,255,255,0.38)" }}>
                  <td style={{ cursor: "pointer", fontSize: "13px" }} onClick={() => onClickRoute("/dashboard/config")}>
                    <div className="d-flex justify-content-start">Uygulama Yönetimi</div>
                  </td>
                </tr>
              )}
              {getUserInfo.Rol.includes("5") && (
                <tr className="sidebarHoverStyle" style={{ borderBottom: "1px solid rgba(255,255,255,0.38)" }}>
                  <td style={{ cursor: "pointer", fontSize: "13px" }} onClick={() => onClickRoute("/dashboard/users")}>
                    <div className="d-flex justify-content-start">Kullanıcı Yönetimi</div>
                  </td>
                </tr>
              )}
              <tr className="sidebarHoverStyle" style={{ borderBottom: "1px solid rgba(255,255,255,0.38)" }}>
                <td
                  style={{ cursor: "pointer", fontSize: "13px", color: "orange", fontWeight: "bold" }}
                  onClick={async () => {
                    await axios.get(_serverUrl2 + "/main/version").then((res) => {
                      window.open(res.data.rows[0].url, "_blank");
                    });
                  }}
                >
                  <div className="d-flex justify-content-start">Uygulamayı İndir</div>
                </td>
              </tr>
              <tr className="sidebarHoverStyle" style={{ borderBottom: "1px solid rgba(255,255,255,0.38)" }}>
                <td style={{ cursor: "pointer", fontSize: "13px", color: "#ec7575", fontWeight: "bold" }} onClick={() => onClickRoute("/dashboard/destek")}>
                  <div className="d-flex justify-content-start">Hata Bildir</div>
                </td>
              </tr>
            </thead>
          </table>
        )}
        <div style={{ bottom: "5px", left: "5px", position: "absolute" }}>
          <img
            src={noktasal}
            title="Noktasal Yazılım"
            onClick={() => window.open("http://noktasal.com.tr/", "_blank")}
            width="32px"
            alt=""
            style={{ filter: "brightness(0) invert(1)", opacity: "0.3", cursor: "pointer" }}
          />
        </div>
      </div>
      <div id="sideBarCloser" className="sideBarCloser" style={{ display: "none" }} onClick={() => visibleSidebar()}>
        {" "}
      </div>
    </>
  );
}
